<template>
    <svg  :height="height"
    :width="width"
    :fill="fill" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 26 26;" xml:space="preserve">

		<path d="M32,271.692v192c0,17.664,14.368,32,32,32h160v-224H32z"/>
	<path d="M480,143.692H378.752c7.264-4.96,13.504-9.888,17.856-14.304c25.824-25.952,25.824-68.192,0-94.144
			c-25.088-25.28-68.8-25.216-93.856,0c-13.888,13.92-50.688,70.592-45.6,108.448h-2.304c5.056-37.856-31.744-94.528-45.6-108.448
			c-25.088-25.216-68.8-25.216-93.856,0C89.6,61.196,89.6,103.436,115.36,129.388c4.384,4.416,10.624,9.344,17.888,14.304H32
			c-17.632,0-32,14.368-32,32v48c0,8.832,7.168,16,16,16h208v-64h64v64h208c8.832,0,16-7.168,16-16v-48
			C512,158.06,497.664,143.692,480,143.692z M222.112,142.636c0,0-1.344,1.056-5.92,1.056c-22.112,0-64.32-22.976-78.112-36.864
			c-13.408-13.504-13.408-35.52,0-49.024c6.496-6.528,15.104-10.112,24.256-10.112c9.12,0,17.728,3.584,24.224,10.112
			C208.128,79.5,229.568,134.924,222.112,142.636z M295.776,143.692c-4.544,0-5.888-1.024-5.888-1.056
			c-7.456-7.712,13.984-63.136,35.552-84.832c12.896-13.024,35.456-13.088,48.48,0c13.44,13.504,13.44,35.52,0,49.024
			C360.128,120.716,317.92,143.692,295.776,143.692z"/>
	
		<path d="M288,271.692v224h160c17.664,0,32-14.336,32-32v-192H288z"/>
	

</svg>

</template>

<script>
export default {
name:'gift',
  props:{
	  fill:{
		  default:"#fff"
	  },
	  height:{
		  default:'20px'
	  },
	  width:{
		  default:'20px'
	  }
  }
}
</script>

<style>

</style>
